import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';

interface OnboardingButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  isConfigured: boolean;
  className?: string;
}

const OnboardingButton: React.FC<OnboardingButtonProps> = ({
  onClick,
  isLoading = false,
  isConfigured,
  className = ''
}) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={onClick}
      disabled={isLoading}
      className={className}
    >
      <ExternalLink className="w-4 h-4 mr-2" />
      {isConfigured
        ? t('stripe.button.completeOnboarding')
        : t('stripe.button.configureStripe')
      }
    </Button>
  );
};

export default OnboardingButton;
